import { render, staticRenderFns } from "./agendamento_especialidade_recepcionista.vue?vue&type=template&id=1088aa3f&scoped=true&"
import script from "./agendamento_especialidade_recepcionista.vue?vue&type=script&lang=js&"
export * from "./agendamento_especialidade_recepcionista.vue?vue&type=script&lang=js&"
import style0 from "./agendamento_especialidade_recepcionista.vue?vue&type=style&index=0&id=1088aa3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1088aa3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDialog,VIcon,VProgressCircular,VSelect,VTextField})
